import { Navigate, useLocation } from 'react-router-dom';
import { useFolderContext } from '~/contexts';

export const ShowsRootRedirect = () => {
  const { landingFolderId } = useFolderContext();
  const location = useLocation();

  return <Navigate replace to={`${landingFolderId}${location.search}`} />;
};
